// @flow
import React from 'react';
import InputCreator, { $defaultInputProps } from '../../containers/ProductForm/InputCreator';

const TextInput = InputCreator(({ defaultInputProps }: { defaultInputProps: $defaultInputProps }) => (
  <input {...defaultInputProps} className="no-uniform" type="text" />
));

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput/index.js